// import { getApplicantSteps } from "../ApplicantSteps";
import BTLSteps from "./BTLSteps";
// import ExpenditureSteps from "./ExpenditureSteps";
// import MortgageSteps from "./MortgageSteps";
import ProtectionSteps from "../ProtectionSteps";
import HolidayLetSteps from "./HolidayLetSteps";
import HolidayHomeSteps from "./HolidayHomeSteps";
import ModifiedSimpleSteps from "./ModifiedSimpleSteps";
import AppointmentSteps from "../AppointmentSteps";
import DefaultSteps from "../DefaultSteps";
import SwitchSteps from "../SwitchSteps";
import { ConversationStep, Theme } from "../../interfaces";
// import WealthManagementSteps from "../wealth";

import IllustrationPage from "../../components/custom/IllustrationPage";
import SendNewLead from "../../components/custom/SendNewLead";
import StripePayment from "../../components/custom/StripePayment";
import EscalationSteps from "../EscalationSteps";
import CSQuestionnaire from "../cs-questionnaire";
import WealthSteps from "../wealth/WealthSteps";

const FullSteps = (theme: Theme) => {
    if (theme.customFlowData) {
        let mainFlow = theme.customFlowData.flow;
        if (theme.customFlowData.importedFlows) {
            const importedFlows = theme.customFlowData?.importedFlows.map((data: any) => data.flow);
            let combinedImportedFlows: any = [];
            importedFlows.forEach((data: any) =>
                data.forEach((_data: any) => combinedImportedFlows.push(_data))
            );
            mainFlow = [...mainFlow, ...combinedImportedFlows];
        }

        return [
            ...mainFlow,
            ...ModifiedSimpleSteps(theme),
            ...ProtectionSteps(theme),
            ...BTLSteps,
            ...HolidayLetSteps,
            ...HolidayHomeSteps,
            ...AppointmentSteps(theme),
            ...DefaultSteps(theme),
            ...SwitchSteps(theme),
            ...EscalationSteps,
            ...WealthSteps(theme),
            ...CSQuestionnaire(theme),
            {
                id: "pay",
                type: "bot",
                component: <StripePayment />,
            },
            {
                id: "product_item",
                message: "Which product would you like to avail?",
                type: "bot",
                options: (values) => {
                    const theme = values?.theme as Theme;
                    const { products } = theme;

                    return products?.map((product) => ({
                        label: product?.title,
                        value: product?.id,
                        trigger: "pay",
                    }));
                },
            },
            {
                id: "how_can_we_help",
                type: "bot",
                custom_value: (value: any) => {
                    if (value === "Protection Review" || theme.config?.disableMortgageFlow) {
                        return {
                            key: "mortgage_type",
                            value,
                        };
                    }

                    return {
                        key: "how_can_we_help",
                        value,
                    };
                },
                disable: () =>
                    theme?.config?.disableMortgageFlow || theme?.config?.disableLifeInsuranceFlow,
                message: "How can I help?",
                options: [
                    {
                        label: "Mortgage",
                        value: "Mortgage",
                        trigger: (values) => {
                            if (values?.theme?.apiKey === "45e71ac0-4e4b-415f-9d35-a330e4485c47") {
                                return "marketing_purpose";
                            }

                            return "mortgage_type";
                        },
                    },
                    theme?.apiKey === "45e71ac0-4e4b-415f-9d35-a330e4485c47"
                        ? {
                              label: "Book an appointment",
                              value: "Book an appointment",
                              trigger: "applicant1_firstName",
                          }
                        : {
                              label: "Life Insurance",
                              value: "Protection Review",
                              trigger: (values: any) => {
                                  if (
                                      values?.theme?.apiKey ===
                                      "45e71ac0-4e4b-415f-9d35-a330e4485c47"
                                  ) {
                                      return "marketing_purpose";
                                  }

                                  return "household";
                              },
                              enable: (values: any) => {
                                  return !values?.simplified;
                              },
                          },
                ],
                ...(theme?.config?.disableMortgageFlow &&
                    !theme?.config?.disableLifeInsuranceFlow && {
                        trigger: "household",
                    }),
                ...(!theme?.config?.disableMortgageFlow &&
                    theme?.config?.disableLifeInsuranceFlow && {
                        trigger: "mortgage_type",
                    }),
            },
            {
                id: "marketing_purpose",
                type: "bot",
                message:
                    "Are you happy for your details to be stored on our database, which may then be used for marketing purposes?",
                options: [
                    {
                        label: "Yes",
                        value: "Yes",
                        trigger: (values) => {
                            if (values?.mortgage_type === "Protection Review") {
                                return "household";
                            }

                            return "mortgage_type";
                        },
                    },
                    {
                        label: "No",
                        value: "No",
                        trigger: (values) => {
                            if (values?.mortgage_type === "Protection Review") {
                                return "household";
                            }

                            return "mortgage_type";
                        },
                    },
                ],
            },
            {
                id: "pay",
                type: "bot",
                component: <StripePayment />,
            },
            {
                id: "loading_illustration",
                type: "bot",
                message: "Please wait while we scan the market...",
                trigger: "illustration_page",
            },
            {
                id: "illustration_page",
                type: "bot",
                message: "Please wait while we scan the market...",
                trigger: () =>
                    theme.apiKey === "d8eccbf3-bfa9-435b-9735-c91641c5446e"
                        ? "brief_situation_mortgage"
                        : theme.apiKey === "bc247ec7-eb81-4a68-a0ed-52748d0ec34a"
                        ? "pre_talk_with_advisor"
                        : "talk_with_advisor",
                component: <IllustrationPage />,
            },
            {
                id: "brief_situation_mortgage",
                message:
                    "Would you like to provide a brief outline of your situation at this stage?",
                type: "bot",
                options: [
                    {
                        label: "Yes",
                        value: "Yes",
                        trigger: "share_situation_mortgage",
                    },
                    {
                        label: "No",
                        value: "No",
                        trigger: "talk_with_advisor",
                    },
                ],
            },
            {
                id: "share_situation_mortgage",
                type: "bot",
                message: "",
                input: {
                    placeholder: "Type here...",
                    type: "textarea-solo",
                },
                trigger: "talk_with_advisor",
            },
            {
                id: "blank_send",
                message: "",
                type: "bot",
                component: <SendNewLead />,
                end: true,
                playAnimation: true,
            },
            {
                id: "after_illu_video",
                type: "bot",
                video:
                    //TODO: This is a coreco specific update. To be remove once custom flows are implemented.
                    theme?.apiKey === "fbb8a34f-0bb0-40c0-a007-7a0f07a68341"
                        ? `${process.env.REACT_APP_COMMS_URL}/download/files/public/362e2189-b6e7-4641-9f7a-82fa1f4b78ef.mp4`
                        : `${process.env.REACT_APP_COMMS_URL}/download/files/public/88777r71-45r6-4166-8o54-85818151586m.mp4`,
                trigger: "talk_with_advisor",
            },
        ] as ConversationStep[];
    }

    let firstStep: any[] = [];

    if (theme?.apiKey !== "69636cc7-fe1c-4b95-a93e-9a8ed4503a77") {
        firstStep.push({
            id: "video_greeting",
            video:
                //TODO: This is coreco specific update. To be remove once custom flows are implemented.
                theme?.apiKey === "fbb8a34f-0bb0-40c0-a007-7a0f07a68341"
                    ? `${process.env.REACT_APP_COMMS_URL}/download/files/public/6851f1b4-3319-41f6-8a04-c45dd1eff4ac.mp4`
                    : `${process.env.REACT_APP_COMMS_URL}/download/files/public/CaC83633-3a77-4667-25C3-2C7871586038.mp4`,
            type: "bot",
            trigger: "1",
        });
    }

    return firstStep.concat([
        {
            id: "1",
            type: "bot",
            message: "Hey! 👋",
            trigger: (values: any) => {
                //TODO: This is a coreco specific update. To be remove once custom flows are implemented.

                if (
                    values?.theme?.apiKey === "fbb8a34f-0bb0-40c0-a007-7a0f07a68341" ||
                    values?.theme?.apiKey === "546d6807-a0f0-45ef-8bf9-adfc7077b187"
                ) {
                    return "coreco-greeting";
                }

                //TODO: END OF LINE

                if (values?.theme?.version === "short") {
                    return "3";
                }

                return "2";
            },
        },
        {
            id: "2",
            type: "bot",
            message: `My name is <strong>${theme?.customization?.botName}</strong> - I'm an AI Assistant.`,
            trigger: "how_can_we_help",
            //trigger: "talk_with_advisor",
        },
        //TODO: This is a coreco specific update. To be remove once custom flows are implemented.
        {
            id: "coreco-greeting",
            type: "bot",
            message: `My name is <strong>${theme?.customization?.botName}</strong> - I'm the Coreco AI Assistant.`,
            trigger: "coreco-extra-greeting",
        },
        {
            id: "coreco-extra-greeting",
            type: "bot",
            message:
                "My job is to ask you a few questions and connect you with a member of the team.",
            trigger: "how_can_we_help",
        },
        //TODO: END OF LINE
        {
            id: "how_can_we_help",
            type: "bot",
            custom_value: (value: any) => {
                if (value === "Protection Review" || theme.config?.disableMortgageFlow) {
                    return {
                        key: "mortgage_type",
                        value,
                    };
                }

                return {
                    key: "how_can_we_help",
                    value,
                };
            },
            disable: () =>
                theme?.config?.disableMortgageFlow || theme?.config?.disableLifeInsuranceFlow,
            message: "How can I help?",
            options: [
                {
                    label: "Mortgage",
                    value: "Mortgage",
                    trigger: (values) => {
                        if (values?.theme?.apiKey === "45e71ac0-4e4b-415f-9d35-a330e4485c47") {
                            return "marketing_purpose";
                        }

                        return "mortgage_type";
                    },
                },
                {
                    label: "Life Insurance",
                    value: "Protection Review",
                    trigger: (values) => {
                        if (values?.theme?.apiKey === "45e71ac0-4e4b-415f-9d35-a330e4485c47") {
                            return "marketing_purpose";
                        }

                        return "household";
                    },
                    enable: (values) => {
                        return !values?.simplified;
                    },
                },
            ],
            ...(theme?.config?.disableMortgageFlow &&
                !theme?.config?.disableLifeInsuranceFlow && {
                    trigger: "household",
                }),
            ...(!theme?.config?.disableMortgageFlow &&
                theme?.config?.disableLifeInsuranceFlow && {
                    trigger: "mortgage_type",
                }),
        },
        {
            id: "marketing_purpose",
            type: "bot",
            message:
                "Are you happy for your details to be stored on our database, which may then be used for marketing purposes?",
            options: [
                {
                    label: "Yes",
                    value: "Yes",
                    trigger: (values) => {
                        if (values?.mortgage_type === "Protection Review") {
                            return "household";
                        }

                        return "mortgage_type";
                    },
                },
                {
                    label: "No",
                    value: "No",
                    trigger: (values) => {
                        if (values?.mortgage_type === "Protection Review") {
                            return "household";
                        }

                        return "mortgage_type";
                    },
                },
            ],
        },
        {
            id: "loading_illustration",
            type: "bot",
            // video:
            //   //TODO: This is a coreco specific update. To be remove once custom flows are implemented.
            //   theme?.apiKey === "fbb8a34f-0bb0-40c0-a007-7a0f07a68341"
            //     ? `${process.env.REACT_APP_COMMS_URL}/download/files/public/5f15ed6a-8308-4c41-8089-1e15b63cb6e9.mp4`
            //     : `${process.env.REACT_APP_COMMS_URL}/download/files/public/1158m906-5m0m-4198-9o88-19861ro51186.mp4`,
            message: "Please wait while we scan the market...",
            trigger: "illustration_page",
        },
        {
            id: "illustration_page",
            type: "bot",
            trigger: "after_illu_video",
            component: <IllustrationPage />,
        },
        {
            id: "after_illu_video",
            type: "bot",
            video:
                //TODO: This is a coreco specific update. To be remove once custom flows are implemented.
                theme?.apiKey === "fbb8a34f-0bb0-40c0-a007-7a0f07a68341"
                    ? `${process.env.REACT_APP_COMMS_URL}/download/files/public/362e2189-b6e7-4641-9f7a-82fa1f4b78ef.mp4`
                    : `${process.env.REACT_APP_COMMS_URL}/download/files/public/88777r71-45r6-4166-8o54-85818151586m.mp4`,
            trigger: "talk_with_advisor",
        },
        ...ProtectionSteps(theme),
        ...BTLSteps,
        ...HolidayLetSteps,
        ...HolidayHomeSteps,
        ...ModifiedSimpleSteps(theme),
        ...AppointmentSteps(theme),
        ...DefaultSteps(theme),
        ...SwitchSteps(theme),
        ...EscalationSteps,
        ...WealthSteps(theme),
        ...CSQuestionnaire(theme),
    ] as ConversationStep[]);
};

export default FullSteps;
